import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Divider, Flex, Input, PopoverBody, PopoverContent, PopoverHeader } from '@chakra-ui/react';
import { styles } from './my-status.styles';
import theme from '../../theme';
const MyStatus = (props)=>{
    const { listStatus, updateStatus, user, context } = props;
    const classes = styles();
    let { statusList } = useSelector((state)=>state.myStatus);
    const [statusRows, setStatusRows] = useState(statusList?.rowValues);
    const [search, setSearch] = useState('');
    useEffect(()=>{
        const fetchStatusList = async ()=>{
            await listStatus(context?.activeContext?.tenantId);
        };
        if (statusRows.length === 0) {
            fetchStatusList();
        }
    // eslint-disable-next-line
    }, []);
    useEffect(()=>{
        setStatusRows(statusList?.rowValues);
    }, [
        statusList
    ]);
    const handleSearch = (e)=>{
        setSearch(e.target.value);
    };
    const handleUpdateStatus = (status)=>{
        updateStatus(status, user, context);
    };
    return /*#__PURE__*/ _jsxs(PopoverContent, {
        sx: classes['.statusPopover'],
        children: [
            /*#__PURE__*/ _jsxs(PopoverHeader, {
                sx: classes['.statusHeader'],
                children: [
                    "Change status to:",
                    /*#__PURE__*/ _jsx(Divider, {
                        sx: classes['.divider']
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(PopoverBody, {
                sx: classes['.statusPopoverBody'],
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        type: "text",
                        onChange: handleSearch,
                        placeholder: 'Find a status',
                        sx: classes['.searchInput'],
                        _placeholder: {
                            color: theme.colors.text['lowEmphasis']
                        }
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        direction: 'column',
                        children: statusRows?.map((row, idx)=>{
                            if (search === '' || row.Reasons.toLowerCase().includes(search.toLowerCase())) {
                                return /*#__PURE__*/ _jsxs(Flex, {
                                    direction: 'row',
                                    sx: classes['.statusRow'],
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            style: {
                                                ...classes['.statusCircle'],
                                                backgroundColor: row.Color === 'Blue' ? theme.colors.text['lowEmphasis'] : row.Color
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: 'ghost',
                                            onClick: ()=>handleUpdateStatus(row.Reasons),
                                            style: classes['.statusButton'],
                                            children: row.Reasons
                                        })
                                    ]
                                }, idx);
                            }
                            return /*#__PURE__*/ _jsx(_Fragment, {});
                        })
                    })
                ]
            })
        ]
    });
};
export { MyStatus };
